import type React from 'react';
import * as DOM from 'react-dom';
import { ModalHeader } from './ModalHeader';
import styles from './modal.module.css';

export const Modal = ({
  isOpen,
  onClose,
  children,
  title = '',
  modalWidth = 700,
  minHeight,
  hideHeader = false,
}: {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  title?: string | React.ReactNode;
  modalWidth?: number;
  minHeight?: number | string;
  hideHeader?: boolean;
}) => {
  if (!isOpen) return null;

  return DOM.createPortal(
    <div className={styles.overlay}>
      <div
        id={'modal'}
        className={styles.content}
        style={{
          width: `${modalWidth}px`,
          minHeight: minHeight ? (typeof minHeight === 'number' ? `${minHeight}px` : minHeight) : undefined,
        }}
      >
        {!hideHeader && <ModalHeader onClose={onClose} title={title ?? ''} />}
        {children}
      </div>
    </div>,
    document.body,
  );
};
